import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from "@spartacus/core";
import { productVariantsTranslationChunksConfig, productVariantsTranslationsCs } from "@spartacus/product/variants/assets";
import { ProductVariantsRootModule, PRODUCT_VARIANTS_FEATURE } from "@spartacus/product/variants/root";
import { SpartacusFeaturesModule } from '../../spartacus-features.module';
import { AppComponent } from '../../../app.component';
import { AppModule } from '../../../app.module';

@NgModule({
  declarations: [],
  imports: [
    ProductVariantsRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [PRODUCT_VARIANTS_FEATURE]: {
        module: () =>
          import('@spartacus/product/variants').then((m) => m.ProductVariantsModule),
      },
    }
  }),
  provideConfig(<I18nConfig>{
    i18n: {
      resources: productVariantsTranslationsCs,
      chunks: productVariantsTranslationChunksConfig,
    },
  })
  ]
})
export class ProductVariantsFeatureModule { }
